<template>
  <Row>
    <ColumnUi
      class="table-scroll"
      xs="12"
      style="overflow-x:auto; display:flex"
    >
      <slot name="controls"></slot>
    </ColumnUi>
  </Row>
  <br />
  <Row>
    <ColumnUi xs="12" style=" display:flex">
      <!--
         <div>
        <label>
          <span class="pag-hide">Buscar: </span>
        </label>
        <input v-model="filteredData" placeholder="Buscar" />
      </div> -->
      <div style="margin-left:auto">
        <div>
          <span class="pag-hide">Mostrar&nbsp;</span>
          <select
            v-model="paginacionCtrl"
            name="igp-table_length"
            aria-controls="igp-table"
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="-1">Todos</option>
          </select>
          <span class="pag-hide">&nbsp;reportes</span>
        </div>
      </div>
    </ColumnUi>
  </Row>
  <Row>
    <ColumnUi class="table-scroll" xs="12" style="overflow-x:auto">
      <slot name="datosViwer"></slot>
    </ColumnUi>
  </Row>
  <Row>
    <ColumnUi xs="12">
      <div v-if="!datosTmp.length">
        {{ textoNulo }}
      </div>
      <div v-if="datosTmp.length && !filteredData">
        {{ sustantivo }} del {{ posicion }} al
        {{
          posicion + paginacion - 1 > datosTmp.length
            ? datosTmp.length
            : posicion + paginacion - 1
        }}
        de un total de {{ datosTmp.length }}
      </div>
      <div v-if="datosTmp.length && filteredData">
        {{ datos.length }} {{ sustantivo }} de un total de {{ datosTmp.length }}
      </div>
      <div>
        <span :class="posicion == 1 ? 'desactivado' : ''" @click="anterior()">
          <span>&lt;&nbsp;</span>
          <span>Anterior</span>
        </span>
        <span
          style="margin-left:40px"
          :class="
            posicion + paginacion - 1 >= datosTmp.length ? 'desactivado' : ''
          "
          @click="siguiente()"
        >
          <span>Siguiente</span>
          <span> ></span>
        </span>
      </div>
    </ColumnUi>
  </Row>
  <br />
  <br />
</template>
<script>
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
export default {
  name: "paginacion",
  props: {
    datosTmp: Array,
    textoNulo: String,
    sustantivo: String,
  },
  data() {
    return {
      posicion: 0,
      paginacion: 10,
      paginacionCtrl: 10,
      datos: [],
      filteredData: "",
      paginacionOpcional: "",
    };
  },
  components: {
    Row,
    ColumnUi,
  },
  watch: {
    paginacionCtrl: function(val) {
      // this.obtenerEventos(this.year,this.mes,this.paginacion)
      this.paginacion = parseInt(this.paginacionCtrl);
      if (val == -1) {
        this.paginacion = this.datosTmp.length;
      }
      this.posicion = 1;
      this.datos = this.datosTmp.slice(
        this.posicion - 1,
        this.posicion - 1 + this.paginacion
      );
      this.$emit("passPaginado", this.datos);
    },
    filteredData: function(filterKey) {
      this.filtrado(filterKey);
    },
    paginacionOpcional: function(value) {
      this.filtrado(value);
    },
    datosTmp: function() {
      this.datos = this.datosTmp.slice(
        this.posicion - 1,
        this.posicion - 1 + this.paginacion
      );
      this.$emit("passPaginado", this.datos);
    },
  },
  methods: {
    filtrado: function(filterKey) {
      filterKey = filterKey.toLowerCase();
      if (filterKey) {
        let data = this.datos;
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
        this.datos = data;
        this.posicion = data.length;
        this.$emit("passPaginado", this.datos);
      } else {
        this.datos = this.datosTmp;
        this.$emit("passPaginado", this.datos);
      }
    },
    siguiente: function() {
      this.filteredData = "";
      this.paginacionOpcional = "";
      if (this.posicion + this.paginacion - 1 < this.datosTmp.length) {
        this.posicion = this.posicion + this.paginacion;
        this.datos = this.datosTmp.slice(
          this.posicion - 1,
          this.posicion - 1 + this.paginacion
        );
        this.$emit("passPaginado", this.datos);
      }
    },
    anterior: function() {
      this.filteredData = "";
      this.paginacionOpcional = "";
      if (this.posicion !== 1) {
        this.posicion = this.posicion - this.paginacion;
        this.datos = this.datosTmp.slice(
          this.posicion - 1,
          this.posicion - 1 + this.paginacion
        );
        this.$emit("passPaginado", this.datos);
      }
    },
  },
  created() {
    this.posicion = 1;
    this.paginacion = 10;
    this.datos = this.datosTmp.slice(
      this.posicion - 1,
      this.posicion - 1 + this.paginacion
    );
    this.$emit("passPaginado", this.datos);
  },
};
</script>
<style lang="scss">
/* @use "@/assets/styles/settings/_variables.scss"; */
.desactivado {
  color: rgba(40, 40, 40, 0.3) !important;
}
.desactivado:hover {
  background-color: transparent !important;
}
.pag-show {
  display: none;
}
@media (max-width: 770px) {
  .pag-hide {
    display: none;
  }
  .pag-show {
    display: unset;
  }
}

.table-scroll::-webkit-scrollbar {
  height: 8px;
}

.table-scroll::-webkit-scrollbar-track {
  background-color: #c0c0c0;
}

.table-scroll::-webkit-scrollbar-thumb {
  background-color: #0200ae;
}
</style>
